import BaseService from "src/packages/BaseService";

export default class GameService extends BaseService {
	static get className () {
		return "game";
	}

	static async duplicate (id, form) {
		const response = await BaseService.getService().post("game/duplicate/" + id, form);
		return response.data;
	}

	static async update(game) {
		const response = await BaseService.getService().patch("game/" + game.id, game);
		return response.data;
	}
	static async count() {
		return BaseService.getPublicService().get("count/" + this.className ).then(
			response => {
				if (response.data >= 0) {
					return response.data;
				} else {
					throw new Error(response.data);
				}
			}
		);
	}
}
